module.exports = __webpack_public_path__ + "static/media/lunbo4.aadb3639.png";